<div class="modal-header mx-0 pb-4">
  <span class="nav-secondary nav-font18 font-weight-bold mt-4">Launch Confirmation</span>
  @if (gettingDetails) {
    <i class="loading mt-4 ml-3"></i>
  }
  <i class="far fa-close ml-auto grey4 nav-font18 p-1" (click)="loadingLaunch ? null : cancel();"></i>
</div>
<div class="modal-body pt-0">
  @if (details != null) {
  <h5 class="grey5 d-block nav-font14 font-weight-bold mb-4 pb-2">In order to launch your survey, please confirm the following:</h5>
  <div class="row nav-font14 grey4 mx-0">
    <div class="col d-flex align-items-center p-0">
      <label for="inputLiveUrl" class="mr-2 font-weight-bold grey6 text-nowrap required">
        Live URL
      </label>
      <span class="grey5 ml-3 w-100">
        <input [(ngModel)]="details.surveyLink"
               (ngModelChange)="checkCanLaunch()"
               placeholder="Enter live URL here"
               type="text"
               name="surveyLink"
               id="inputLiveUrl"
               #inputLiveUrl
               class="nav-font14 form-control form-control-sm form-control-nav">
      </span>
    </div>
  </div>
  @if (details.surveyLink !='' && details.surveyLink?.indexOf('#or1#') == -1) {
  <div class="alert alert-warning nav-font14 mb-0 mt-1" role="alert">You must have a variable set to #or1# so that you can track the unique IDs for this project</div>
  }
  <div class="row nav-font14 grey4 mx-0 mt-4 pt-2">
    <div class="col d-flex align-items-center p-0">
      <label class="mr-2 font-weight-bold grey6 text-nowrap required">
        Field dates
      </label>
    </div>
  </div>
  <div class="row grey4 nav-font14 grey4 mt-3 mx-0 d-flex align-items-center date-input">
    <div class="mr-3 label-col">Starts</div>
    <div class="">
      <div class="input-group form-control-date">
        <input type="text" autocomplete="off"
               name="fieldStartDate"
               readonly
               [(ngModel)]="details.fieldStartDate"
               (ngModelChange)="checkCanLaunch()"
               bsDatepicker
               placeholder="Select"
               #dpFieldStartDate="bsDatepicker"
               [bsConfig]="{ dateInputFormat: 'MM/DD/YY', showWeekNumbers:false, returnFocusToInput: true,adaptivePosition: true, customTodayClass: 'todays-date',  selectFromOtherMonth: true }"
               class="form-control nav-font12 date d-inline bg-white w-50 px-2">
        <span class="input-group-text bg-white" (click)="dpFieldStartDate.toggle()"><i class="fak fa-calendar grey4 nav-font14"></i></span>
      </div>
    </div>
  </div>
  <div class="row grey4 nav-font14 mt-3 mx-0 d-flex align-items-center date-input">
    <div class="mr-3 label-col">Ends</div>
    <div class="">
      <div class="input-group form-control-date">
        <input type="text" autocomplete="off"
               name="fieldEndDate"
               readonly
               [(ngModel)]="details.fieldEndDate"
               (ngModelChange)="checkCanLaunch()"
               bsDatepicker
               placeholder="Select"
               #dpFieldEndDate="bsDatepicker"
               [bsConfig]="{ dateInputFormat: 'MM/DD/YY', showWeekNumbers:false, returnFocusToInput: true,adaptivePosition: true, customTodayClass: 'todays-date',  selectFromOtherMonth: true }"
               class="form-control nav-font12 date d-inline bg-white w-50 px-2">
        <span class="input-group-text bg-white" (click)="dpFieldEndDate.toggle()"><i class="fak fa-calendar grey4 nav-font14"></i></span>
      </div>
    </div>
  </div>
  <div class="row d-flex align-items-center nav-font14 mx-0 infoHover mt-4 mb-4 pt-2">
    <span class="grey5 font-weight-bold">Enforce limit</span>
    <i class="fak fa-info grey4 ml-1" container="body" placement="bottom" containerClass="enforce-limit-tooltip"
       tooltip="When enabled, this feature stops traffic once a project or a specific vendor's limit is reached, automatically redirecting new traffic to the 'Overquota' links. In the event of an overall project limit being reached, all traffic will be directed to the respective vendor's 'Overquota' redirect links, bypassing the survey."></i>
    <div class="ml-3">
      <or-toggle-button class="light" size="small" [isChecked]="details.projectFieldLimitEnabled" [(ngModel)]="details.projectFieldLimitEnabled"></or-toggle-button>
    </div>
  </div>
  @if (details.isNavTrial) {

  @if(auth.isAdmin() || !auth.isORInstance()) {
  <div class="row d-flex align-items-center nav-font14 mx-0 pt-2 mb-3 grey5 font-weight-bold">
    Select if you want your project set to de-duplication or to tracking duplications only.
  </div>
  <div class="row d-flex nav-font14 grey5 mx-0 mb-2 ">
    <div class="dedupe-radio-btn">
      <input type="radio" name="radioGroup" class="mr-2" [(ngModel)]="details.isDupeTrackingOnly" [value]="false">
    </div>
    <div class="grey5">
      De-Duplication
      <i class="fak nav-font16 grey4 fa-message-info ml-2" placement="bottom" container="body" containerClass="settings-tooltip"
         tooltip="NAV will block duplicates from entering your survey"></i>
    </div>
  </div>
  <div class="row d-flex nav-font14 grey5 mx-0 mb-4 pb-2 ">
    <div class="dedupe-radio-btn">
      <input type="radio" name="radioGroup" class="mr-2" [(ngModel)]="details.isDupeTrackingOnly" [value]="true">
    </div>
    <div class="grey5">
      Track Duplications Only
      <i class="fak nav-font16 grey4 fa-message-info ml-2" placement="bottom" container="body" containerClass="settings-tooltip"
         tooltip="Duplication will only record dupes but will not block participants."></i>
    </div>
  </div>
  }

  <div class="row d-flex nav-font14 mx-0 mb-4 pb-3">
    <div class="grey5 font-weight-bold">
      CleanID Threshold
      <i class="fak nav-font16 grey4 fa-message-info ml-2" placement="bottom" container="body" containerClass="settings-tooltip"
         [tooltip]="cleanIDThresholdTooltip"></i>
    </div>
    <ng-template #cleanIDThresholdTooltip>
      <div [innerHtml]="cleanIdThresholdTooltipMsg"></div>
    </ng-template>
    <div class="col-4">
      <div class="btn-group w-100 position-relative" dropdown #dropdownFraudDetectionThreshold="bs-dropdown">
        <div id="button-basic" dropdownToggle controls="dropdown-basic" class="d-flex button-container" [ngClass]="dropdownFraudDetectionThreshold.isOpen ? 'open' : 'closed'">
          <span class="nav-font14 cursor-default grey5" [class.grey3]="details.fraudDetectionThreshold == null">{{details.fraudDetectionThreshold == null  ? 'Select threshold' : cleanIdThresholds[details.fraudDetectionThreshold]}}</span>
          <div class="cursor-pointer d-flex align-items-center grey6 ml-auto">
            <i class="far grey4 float-right nav-font16 ml-auto"
               [class.fa-angle-up]="dropdownFraudDetectionThreshold.isOpen"
               [class.mt-1]="!dropdownFraudDetectionThreshold.isOpen"
               [class.fa-angle-down]="!dropdownFraudDetectionThreshold.isOpen">
            </i>
          </div>
        </div>
        <div *dropdownMenu class="dropdown-menu position-absolute dropdown-menu-right py-0 nav-font14 m-0 w-100" role="menu" aria-labelledby="button-basic">
          <div class="menu-container overflow-y">
            <ul class=" py-0 px-0 my-0 noShadow">
              @for (threshold of cleanIdThresholds | keyvalue : asIsOrder; track threshold; let t = $index) {
              <li role="menuitem" class="expandable grey4 nav-font14 d-flex align-items-center px-0"
                  (click)="details.fraudDetectionThreshold = threshold.key">
                <div class="dropdown-list-item cursor-pointer font-weight-normal w-100 px-2">
                  <span>{{threshold.value}}</span>
                </div>
              </li>
              @if (threshold.value != 'Using API') {
              <hr class="p-0 my-0 mx-1">
              }
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
  }
</div>
<div class="modal-footer d-flex align-items-center pb-0 mb-4" [ngClass]="{'my-4 pt-4': details?.isNavTrial == false}">
  @if (details != null) {
    <div class="m-0">
      <div class="or-checkbox pr-4 mr-2 d-inline">
        <span container="body">
          <input type="checkbox" [(ngModel)]="details.applyToMore" id="applyCheckbox">
          <label for="applyCheckbox"></label>
        </span>
      </div>
    <span class="grey5 nav-font14">Apply {{details?.status}} status {{partnerId ? 'to Overall Project' : 'across all vendors'}}</span>
  </div>
  <div class="ml-auto d-flex align-items-center my-0 mr-0">
    <button type="button" class="btn nav-btn-primary btn-sm shadow-none mr-2" (click)="loadingLaunch ? null : cancel();">Cancel</button>
    @if (loadingLaunch) {
      <span class="loading mr-2"></span>
    } 
    <button type="button" class="btn nav-btn-accent btn-sm shadow-none" [class.disabled]="!details?.canLaunch" (click)="updateStatusAndLaunchDetails()">Confirm & Launch</button>
  </div>
  }
</div>
